import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, UntypedFormArray } from '@angular/forms';
import { ValidateDate, ValidateRegex } from '@shared/components/dynamic-form/form-validators/form-validators';
import { DynamicControl } from '@shared/models/dynamic-form-control.model';
import { isNullOrUndefined } from '@shared/utils/utils';
import { ValidatorService } from 'angular-iban';


@Injectable()
export class DynamicFormService {
  toFormGroup(controls: DynamicControl<any>[], caseItemStatus: string) {
    const group: any = {};
    let isDisabled: boolean;
    let controlValue: string;

    controls.forEach(control => {
      if (control.controlType=="table") {
        let tableControl = new UntypedFormArray([]);
        if(control.children){
          control.children.forEach(row => {
            tableControl.push(this.toFormGroup(row, caseItemStatus));
          })
        }
        group[control.key] = tableControl;
     }
     else{
       if (!isNullOrUndefined(control.value)) {
          controlValue = control.value.toString();
        } else {
          controlValue = undefined;
        }

        isDisabled = caseItemStatus === 'Confirmed' || caseItemStatus === 'Processed' || caseItemStatus === 'Closed' || control.viewState === 'NonEditable';
        group[control.key] = new UntypedFormControl({ value: controlValue, disabled: isDisabled });

      //set validators
      group[control.key].setValidators(this.getValidators(control));
     }

    });

    return new UntypedFormGroup(group);
  }

  private getValidators(control: DynamicControl<any>) {
    const validators = new Array();

    if (control.controlType === 'datepicker') {
      validators.push(ValidateDate(control.rangeValues));
    }

    if (control.regex != null) {
      validators.push(ValidateRegex(control.regex));
    }

    if (control.required) {
      validators.push(Validators.required);
    }

    if (control.MOD97) {
      validators.push(ValidatorService.validateIban);
    }

    return validators;
  }
}
